export var letterSpacing = {
    tight: '-0.04em',
    normal: '0em'
};

//# sourceMappingURL=letterSpacing.js.map